<template>
  <TextArea :id="name" :class="{ 'p-invalid': errorMessage }"
            :name="name" :placeholder="placeholder" :value="value"
            aria-describedby="text-error" cols="30" rows="2"
            @update:modelValue="$emit('update:modelValue', $event)"/>
</template>
<script lang="ts" setup>
import TextArea from 'primevue/textarea';
import {toRef} from "vue";

const props = defineProps<{
  placeholder: string,
  name: string,
  errorMessage: any,
  value: string
}>()

const name = toRef(props, 'name');
</script>
